import {ResponsiveModal} from '~library/organisms/ResponsiveModal';

export const ConfirmLeaveModalContainer = (props) => {
  const {isFirstStep, cancelLeave, leave} = props;
  const body = isFirstStep
    ? 'You will lose your card progress. Continue to Step 2 to save your card.'
    : "We've saved your progress.";

  return (
    <ResponsiveModal
      isOpen
      onClose={cancelLeave}
      title="Exit card editor"
      body={body}
      secondaryAction={leave}
      secondaryText="Exit"
      primaryAction={cancelLeave}
      primaryText="Continue editing"
      titleQaId="createFlowUpsellModalLabel"
      bodyQaId="createFlowUpsellModalDescription"
      secondaryQaId="say-yes-btn"
      secondaryImpressionTracking
      primaryQaId="say-no-btn"
    />
  );
};
